import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/vercel/path0/src/templates/DocumentTemplate.js";
import Handler from './onCheckoutFail_handler.mdx';
import Error from './onCheckoutFail_error.mdx';
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const Group = makeShortcode("Group");
const Item = makeShortcode("Item");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <p>{`Called when the checkout flow has failed.`}</p>
    <Group summary='Parameters' mdxType="Group">
	<Item title='error' subtitle='PrimerClientError' mdxType="Item">
		<Error mdxType="Error" />
	</Item>
	<Item title='data' subtitle='object' mdxType="Item">
		<Group summary='Properties' mdxType="Group">
			<Item title='payment' subtitle='object' mdxType="Item">
				When checkout fails, the payment might or might not have been created. If it was created, the payment object
				contains some information regarding it.
				<Group summary='Properties' open mdxType="Group">
					<Item title='id' subtitle='string' mdxType="Item">
						Primer's unique identifier for the payment.
					</Item>
					<Item title='orderId' subtitle='string' mdxType="Item">
						Your order identifier as provided in the client session.
					</Item>
					<Item title='paymentMethodData' subtitle='object' mdxType="Item">
						Optional payment method data - for some payment methods this object will contain additional information on
						the payment.
					</Item>
				</Group>
			</Item>
		</Group>
	</Item>
	<Item title='handler' subtitle='object' mdxType="Item">
		<Handler mdxType="Handler" />
	</Item>
    </Group>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      